export default __webpack_public_path__ + "static/media/LG G3.e251cdb3.png";